/**
 * Arabic interface copy — the reference catalogue. French and English must
 * provide exactly the same keys (enforced by the type system and by tests).
 * Child-facing text is short, warm and never blames; parent-facing text is
 * precise and presents estimates as estimates.
 */
export const ar = {
  app: {
    skipToContent: 'تخطَّ إلى المحتوى',
    loading: 'لحظة من فضلك…',
    back: 'رجوع',
    close: 'إغلاق',
    continue: 'مواصلة',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    save: 'حفظ',
    next: 'التالي',
    start: 'ابدأ',
    delete: 'حذف',
    yes: 'نعم',
    no: 'لا',
    sampleContent: 'محتوى تجريبي',
    sampleContentNotice:
      'هذه الأنشطة أمثلة لم يصادق عليها مربٍّ بعد، وقد لا تطابق برنامج القسم تمامًا.',
    offlineReady: 'تطبيق {app} جاهز للعمل دون إنترنت.',
    updateAvailable: 'نسخة جديدة من {app} متوفّرة.',
    updateNow: 'تحديث',
    later: 'لاحقًا',
    mainNavigation: 'التنقّل الرئيسي',
  },
  errors: {
    title: 'حدث خلل بسيط',
    body: 'لم نتمكّن من عرض هذه الصفحة. تقدّمك محفوظ.',
    reload: 'إعادة التحميل',
    goHome: 'العودة إلى البداية',
    notFound: 'لم نجد هذه الصفحة.',
    storageTitle: 'لا يمكن حفظ التقدّم على هذا المتصفّح',
    storageUnavailable:
      'يبدو أنّ المتصفّح يمنع التخزين المحلّي (مثلًا في وضع التصفّح الخاصّ). افتح {app} في نافذة عاديّة.',
    storageQuota: 'مساحة التخزين ممتلئة. حرّر بعض المساحة على الجهاز ثمّ أعد المحاولة.',
    storageBlocked:
      'تطبيق {app} مفتوح في نافذة أخرى بنسخة مختلفة. أغلق النوافذ الأخرى ثمّ أعد التحميل.',
    storageUnknown: 'تعذّر فتح التخزين المحلّي.',
    saveFailed: 'لم نتمكّن من حفظ آخر إجابة. يمكنك المواصلة، لكن قد لا تُحفظ هذه الحصّة.',
    contentMissing: 'لا توجد أنشطة متاحة هنا بعد.',
  },
  welcome: {
    title: 'مرحبًا بك في {app}',
    subtitle:
      'ألعاب تعليميّة قصيرة في العربيّة والرياضيّات واللغات والإيقاظ العلمي، من التحضيري إلى السنة السادسة.',
    start: 'لنبدأ!',
    privacyTitle: 'خصوصيّة طفلك أوّلًا',
    privacy1: 'لا بريد إلكتروني ولا رقم هاتف ولا اسم حقيقي.',
    privacy2: 'كلّ التقدّم يُحفظ على هذا الجهاز فقط.',
    privacy3: 'لا إعلانات ولا أدوات تتبّع.',
    parentArea: 'فضاء الوليّ',
  },
  profiles: {
    title: 'مَن سيتعلّم اليوم؟',
    add: 'إضافة متعلّم',
    play: 'ابدأ مع {name}',
    anonymous: 'متعلّم',
    level: 'المستوى: {level}',
    switch: 'تغيير المتعلّم',
  },
  onboarding: {
    title: 'ملفّ متعلّم جديد',
    step: 'الخطوة {current} من {total}',
    avatarTitle: 'اختر شخصيّتك',
    nicknameLabel: 'لقب صغير (اختياري)',
    nicknameHint: 'مثل «نجمة» أو «بطل». لا تكتب اسمك الكامل.',
    levelTitle: 'في أيّ قسم أنت؟',
    levelHint: 'يختار الوليّ القسم الذي يدرس فيه الطفل فعلًا، وليس القسم المناسب لعمره.',
    schoolTypeTitle: 'نوع المدرسة',
    schoolTypeHint: 'نستعمل حاليًّا البرنامج الوطني للمدارس العموميّة والخاصّة.',
    variantTitle: 'البرنامج',
    languageTitle: 'لغة التطبيق',
    preferencesTitle: 'تفضيلات',
    soundEffects: 'أصوات خفيفة عند الإجابة',
    speech: 'زرّ «استمع» لقراءة الكلمات',
    largeText: 'نصّ كبير',
    reducedMotion: 'حركات أقلّ',
    finish: 'إنشاء الملفّ',
    nicknameTooLong: 'اللقب طويل جدًّا (24 حرفًا على الأكثر).',
    color: 'اللون {number}',
    colorGroup: 'لون الخلفيّة',
  },
  avatars: {
    owl: 'بومة',
    cat: 'قطّة',
    lion: 'أسد',
    turtle: 'سلحفاة',
    fish: 'سمكة',
    bee: 'نحلة',
    rabbit: 'أرنب',
    fox: 'ثعلب',
  },
  nav: {
    home: 'الرئيسيّة',
    subjects: 'الموادّ',
    rewards: 'جوائزي',
    review: 'مراجعة',
    settings: 'الإعدادات',
    parent: 'الوليّ',
  },
  home: {
    greeting: 'مرحبًا {name}!',
    greetingAnonymous: 'مرحبًا!',
    subtitle: 'ماذا سنتعلّم اليوم؟',
    continueTitle: 'نواصل التعلّم',
    continueCta: 'هيّا بنا',
    missionTitle: 'مهمّة اليوم',
    missionBody: '{count} أسئلة قصيرة من مواضيع مختلفة.',
    missionDone: 'أنجزت مهمّة اليوم. أحسنت!',
    missionCta: 'ابدأ المهمّة',
    missionAgain: 'تدرّب أكثر',
    subjects: 'الموادّ',
    garden: 'حديقتي',
    gardenHint: 'كلّ هدف تتقنه يصبح زهرة في حديقتك.',
    flowers: {
      zero: 'لا أزهار بعد',
      one: 'زهرة واحدة',
      two: 'زهرتان',
      few: '{count} أزهار',
      many: '{count} زهرة',
      other: '{count} زهرة',
    },
    rewardsLink: 'جوائزي',
    reviewLink: 'مراجعة',
    reviewDue: {
      zero: 'لا مراجعة اليوم',
      one: 'مراجعة واحدة تنتظرك',
      two: 'مراجعتان تنتظرانك',
      few: '{count} مراجعات تنتظرك',
      many: '{count} مراجعة تنتظرك',
      other: '{count} مراجعة تنتظرك',
    },
  },
  subjects: {
    title: 'الموادّ',
    objectives: {
      zero: 'لا أهداف',
      one: 'هدف واحد',
      two: 'هدفان',
      few: '{count} أهداف',
      many: '{count} هدفًا',
      other: '{count} هدف',
    },
    none: 'لا توجد مواد متاحة لهذا المستوى بعد.',
  },
  map: {
    title: 'خريطة التعلّم',
    earlier: 'مراجعة السنوات السابقة',
    open: 'افتح',
    empty: 'لا توجد أهداف لهذه المادّة في مستواك بعد.',
  },
  mastery: {
    status: {
      notStarted: 'لم يبدأ بعد',
      learning: 'نتعلّم',
      needsPractice: 'يحتاج إلى تدريب',
      progressing: 'في تقدّم',
      provisionalMastery: 'إتقان مبدئي',
    },
    reason: {
      notStarted: 'لا توجد إجابات مسجّلة بعد.',
      gatheringEvidence:
        'عدد الأسئلة المُجاب عنها ({answered}) ما زال قليلًا: نحتاج إلى مزيد من التمارين قبل أيّ تقدير.',
      consistentAcrossDays:
        '{percent}٪ من الإجابات الأخيرة صحيحة من المحاولة الأولى، في أيّام مختلفة (عددها {days}).',
      needsConfirmation:
        '{percent}٪ من الإجابات الأخيرة صحيحة. نحتاج إلى تدريب في يوم آخر لتأكيد الإتقان.',
      mostlyCorrect: '{percent}٪ من الإجابات الأخيرة صحيحة من المحاولة الأولى.',
      frequentMistakes: '{percent}٪ فقط من الإجابات الأخيرة صحيحة من المحاولة الأولى.',
      mixedResults: 'النتائج الأخيرة متفاوتة ({percent}٪ صحيحة من المحاولة الأولى).',
    },
    trend: {
      improving: 'في تحسّن',
      stable: 'مستقرّ',
      declining: 'في تراجع مؤخّرًا',
      unknown: 'غير محدّد بعد',
    },
    estimateNote: 'تقدير مبنيّ على التمارين المسجّلة، وليس حكمًا على قدرات الطفل.',
  },
  lesson: {
    practise: 'لنتدرّب',
    chooseGame: 'اختر لعبة',
    recommended: 'مقترحة',
    noGames: 'لا توجد ألعاب متاحة لهذا الهدف بعد.',
    workedExample: 'مثال محلول',
    tip: 'نصيحة',
    rule: 'قاعدة',
    examples: 'أمثلة',
    status: 'تقدّمك',
  },
  rules: {
    title: 'دفتر القواعد',
    link: {
      zero: 'دفتر القواعد',
      one: 'دفتر القواعد: قاعدة واحدة',
      two: 'دفتر القواعد: قاعدتان',
      few: 'دفتر القواعد: {count} قواعد',
      many: 'دفتر القواعد: {count} قاعدة',
      other: 'دفتر القواعد: {count} قاعدة',
    },
    empty: 'لا توجد قواعد في هذه المادّة بعد.',
    openLesson: 'افتح الدرس: {lesson}',
  },
  games: {
    'quick-quiz': { name: 'اختبار سريع', description: 'أسئلة متنوّعة قصيرة.' },
    'find-correct': {
      name: 'جد الإجابة الصحيحة',
      description: 'اختر الجواب المناسب من بين عدّة اقتراحات.',
    },
    'missing-number': { name: 'العدد الناقص', description: 'جد العدد المختفي في العمليّة.' },
    'word-builder': { name: 'باني الكلمات', description: 'رتّب الحروف لتكوّن كلمة.' },
    'letter-sound': { name: 'الحرف والصوت', description: 'اربط الحروف بأصواتها وكلماتها.' },
    'sentence-builder': { name: 'باني الجمل', description: 'رتّب الكلمات لتكوّن جملة.' },
    memory: { name: 'بطاقات الذاكرة', description: 'اقلب البطاقات وجد الأزواج.' },
    categorize: { name: 'لعبة التصنيف', description: 'ضع كلّ عنصر في مجموعته.' },
    'true-false': { name: 'صحيح أم خطأ', description: 'قرّر إن كانت الجملة صحيحة.' },
    'daily-mission': { name: 'مهمّة اليوم', description: 'مزيج قصير من المراجعة والتدريب.' },
  },
  voice: {
    answer: 'أجب بصوتك',
    stop: 'توقّف',
    listening: 'أنا أسمعك… قل إجابتك.',
    heard: 'سمعتُ: «{text}».',
    notUnderstood: 'لم أفهم الإجابة. أعد المحاولة أو اضغط على إجابتك.',
    error: {
      'not-allowed': 'الميكروفون غير مسموح به. اطلب من وليّك السماح به في المتصفّح.',
      'no-speech': 'لم أسمع شيئًا. تكلّم بوضوح قرب الجهاز.',
      unavailable: 'الإجابة بالصوت غير متاحة في هذا المتصفّح.',
      aborted: 'توقّف الاستماع.',
      failed: 'تعذّر التعرّف على الصوت الآن. يمكنك الإجابة باللمس.',
    },
    setting: 'الإجابة بالصوت (تجريبيّة)',
    settingDescription:
      'عند التفعيل، يستطيع طفلك أن يجيب عن بعض الأسئلة بصوته. المتصفّح هو الذي يحوّل الصوت إلى نصّ: في Chrome وأندرويد يُرسَل الصوت إلى Google لهذا الغرض، وفي Safari إلى Apple أو يُعالَج على الجهاز. {app} لا يسجّل الصوت ولا يحفظه ولا يرسله إلى خادمه.',
    unsupported: 'هذا المتصفّح لا يدعم التعرّف على الصوت. جرّب Chrome أو Safari.',
  },
  vote: {
    title: 'صوّتوا للنسخة القادمة',
    nav: 'التصويت',
    intro:
      'اختاروا حتى 3 أفكار تريدونها في {app}. الأفكار التي تنال أكبر عدد من الأصوات نُنجزها أوّلًا ونعلن ذلك في «ما الجديد؟». يمكنكم أن تختاروا مع أطفالكم.',
    choose: 'اختاروا حتى {max} أفكار',
    chosen: '{count} من {max}',
    ideaLabel: 'عندكم فكرة أخرى؟ اكتبوها هنا (اختياري)',
    ideaHint: 'لا تكتبوا أسماء أو معلومات شخصيّة عن الأطفال.',
    send: 'أرسل',
    thanks: 'وصل تصويتكم. شكرًا على مساعدتنا في اختيار الخطوة القادمة!',
    alreadyVoted: 'صوّتّم في هذه الجولة. شكرًا!',
    alreadyVotedHint: 'تُفتح جولة جديدة مع النسخة القادمة. يمكنكم دائمًا إرسال فكرة جديدة.',
    ideas: {
      'journey-map': {
        title: 'خريطة الرحلة',
        description: 'سيّارة ObiGo تتقدّم في طريق يمرّ بأماكن تونسيّة كلّما أتقن الطفل هدفًا.',
      },
      'recorded-audio': {
        title: 'أصوات مسجّلة',
        description: 'معلّمة تونسيّة تنطق الحروف والأصوات والكلمات.',
      },
      'teacher-review': {
        title: 'مراجعة المعلّمين',
        description: 'معلّمون يراجعون كلّ الأسئلة والدروس قبل نشرها.',
      },
      'home-tips': {
        title: 'نصائح للبيت',
        description: 'نشاط بسيط في البيت لكلّ صعوبة تظهر في تقرير طفلكم.',
      },
      printables: {
        title: 'أوراق للطباعة',
        description: 'تقرير أسبوعي وتمارين بصيغة PDF.',
      },
      stories: {
        title: 'قصص مصوّرة',
        description: 'قصص قصيرة في أجواء تونسيّة مع ألعاب للفهم.',
      },
      'play-together': {
        title: 'نلعب معًا',
        description: 'الوليّ أو الأخ يطرح السؤال والطفل يجيب على الجهاز نفسه.',
      },
      'reading-comfort': {
        title: 'قراءة مريحة',
        description: 'خيارات تساعد الأطفال ذوي عسر القراءة، وألوان أوضح.',
      },
      'packs-on-demand': {
        title: 'تحميل حسب السنة',
        description: 'تحميل دروس سنة الطفل فقط ليبقى التطبيق خفيفًا.',
      },
      'content-stats': {
        title: 'إحصاءات مجهولة الهويّة (بموافقتكم)',
        description: 'لنكتشف الأسئلة الصعبة أو الخاطئة بسرعة.',
      },
      'lighter-app': {
        title: 'تطبيق أسرع',
        description: 'تحميل أسرع على الهواتف البسيطة والإنترنت الضعيف.',
      },
    },
  },
  whatsNew: {
    title: 'ما الجديد؟',
    intro: 'ما تغيّر في كلّ نسخة، وكثير منه بفضل ملاحظاتكم.',
    version: '{app} — النسخة {version}',
    latest: 'الأحدث',
    banner: 'جديد في {app} (النسخة {version})',
    seeAll: 'اكتشف كلّ الجديد',
    dismiss: 'حسنًا',
    voteHint: 'ماذا تريدون في النسخة القادمة؟',
    voteLink: 'صوّتوا وشاركونا أفكاركم (فضاء الوليّ)',
  },
  play: {
    progress: 'السؤال {current} من {total}',
    check: 'تحقّق',
    hint: 'تلميح',
    hintTitle: 'تلميح',
    correct1: 'أحسنت!',
    correct2: 'رائع، إجابة صحيحة!',
    correct3: 'ممتاز!',
    correctAfterRetry: 'أحسنت! المحاولة الثانية كانت صحيحة.',
    tryAgain: 'لم تصل إلى الإجابة الصحيحة بعد. حاول مرّة أخرى!',
    tryAgainButton: 'حاول مجدّدًا',
    revealed: 'لا بأس، نتعلّم معًا! الإجابة الصحيحة:',
    revealedNoAnswer: 'لا بأس، نتعلّم معًا! انظر إلى الحلّ:',
    explanation: 'كيف نفكّر؟',
    showExplanation: 'اشرح لي',
    hideExplanation: 'إخفاء الشرح',
    next: 'السؤال الموالي',
    finish: 'إنهاء',
    quit: 'خروج',
    quitTitle: 'هل تريد الخروج؟',
    quitBody: 'ستُحفظ الإجابات التي قدّمتها.',
    quitConfirm: 'نعم، أخرج',
    stay: 'أبقى وأواصل',
    listen: 'استمع',
    stop: 'إيقاف',
    true: 'صحيح',
    false: 'خطأ',
    yourAnswer: 'إجابتك',
    clear: 'مسح',
    backspace: 'حذف آخر رقم',
    answerArea: 'مكان الإجابة',
    tilesArea: 'الحروف والكلمات المتاحة',
    tapToPlace: 'اضغط على البطاقات بالترتيب. اضغط على بطاقة في الإجابة لإرجاعها.',
    emptyAnswer: 'أجب أوّلًا ثمّ اضغط «تحقّق».',
    matchHelp: 'اختر عنصرًا من اليمين، ثمّ ما يناسبه من اليسار.',
    matchHelpLtr: 'اختر عنصرًا من القائمة الأولى، ثمّ ما يناسبه من القائمة الثانية.',
    matched: 'مرتبط بـ {item}',
    pairNumber: 'الزوج {number}',
    memoryHelp: 'اقلب بطاقتين في كلّ مرّة.',
    memoryCard: 'بطاقة {number}',
    memoryFound: 'وجدت {found} من {total}',
    categorizeHelp: 'اختر عنصرًا، ثمّ اضغط على المجموعة المناسبة.',
    selected: 'محدَّد',
    putIn: 'ضعه في «{category}»',
    unsorted: 'عناصر للتصنيف',
    wrongParts: 'بعض الإجابات تحتاج إلى مراجعة: انظر إلى العلامات.',
    preview: 'الكلمة',
    noExercises: 'لا توجد أسئلة متاحة لهذه اللعبة بعد.',
    saving: 'جارٍ الحفظ…',
    numberLine: 'مستقيم عددي من {min} إلى {max}',
    countAria: '{count} × {label}',
    blank: 'فراغ',
  },
  results: {
    title: 'انتهت الحصّة!',
    stars: 'حصلت على {count} من 3 نجوم',
    summary: 'إجابات صحيحة: {correct} من {total}.',
    firstTry: '{count} منها من المحاولة الأولى.',
    encourage3: 'عمل دقيق ورائع!',
    encourage2: 'تقدّم جميل، واصل!',
    encourage1: 'كلّ محاولة تجعلك أقوى. سنتدرّب مجدّدًا معًا.',
    newAchievements: 'جائزة جديدة!',
    playAgain: 'العب مرّة أخرى',
    backToMap: 'العودة إلى الخريطة',
    home: 'الرئيسيّة',
    nextStep: 'الخطوة الموالية',
  },
  rewards: {
    title: 'جوائزي',
    earned: 'حصلت عليها',
    locked: 'لم تحصل عليها بعد',
    progress: '{current} من {target}',
    garden: 'حديقتي',
    gardenEmpty: 'تدرّب على هدف في أيّام مختلفة لتنبت أوّل زهرة.',
  },
  achievements: {
    'first-steps': { title: 'الخطوة الأولى', description: 'أنهِ أوّل حصّة.' },
    'math-explorer': { title: 'مستكشف الأعداد', description: 'أنهِ 5 حصص في الرياضيّات.' },
    'letter-friend': { title: 'صديق الحروف', description: 'أنهِ 5 حصص في العربيّة.' },
    'curious-scientist': { title: 'العالِم الفضولي', description: 'أنهِ 5 حصص في الإيقاظ العلمي.' },
    'globe-trotter': { title: 'رحّالة المعرفة', description: 'تدرّب في 3 موادّ مختلفة.' },
    'never-give-up': {
      title: 'لا أستسلم',
      description: 'أجب بشكل صحيح في المحاولة الثانية 10 مرّات.',
    },
    'good-helper': {
      title: 'أستعين بالتلميح',
      description: 'استعمل التلميح ثمّ أجب بشكل صحيح 5 مرّات.',
    },
    'first-flower': { title: 'أوّل زهرة', description: 'أتقن أوّل هدف.' },
    gardener: { title: 'البستاني', description: 'أتقن 5 أهداف.' },
    'mission-1': { title: 'المهمّة الأولى', description: 'أنهِ أوّل مهمّة يوميّة.' },
    'mission-7': { title: 'سبع مهمّات', description: 'أنهِ 7 مهمّات يوميّة (في أيّ وقت).' },
    reviewer: { title: 'المراجع النشيط', description: 'أنهِ 3 حصص مراجعة.' },
    'careful-work': { title: 'عمل متقن', description: 'احصل على 3 نجوم في حصّة.' },
  },
  review: {
    title: 'مراجعة مقترحة',
    intro: 'هذه الأهداف تستحقّ تدريبًا قصيرًا الآن.',
    empty: 'لا شيء للمراجعة الآن. عُد لاحقًا!',
    start: 'ابدأ',
  },
  recommend: {
    kind: {
      review: 'مراجعة',
      prerequisite: 'أساس مهمّ',
      easier: 'تدريب خفيف',
      practice: 'نواصل',
      next: 'هدف جديد',
      start: 'لنبدأ',
    },
    reason: {
      review: {
        zero: 'تدرّبت على هذا الهدف اليوم. مراجعة قصيرة تساعد على التذكّر.',
        one: 'آخر تدريب كان منذ يوم واحد. مراجعة قصيرة تساعد على التذكّر.',
        two: 'آخر تدريب كان منذ يومين. مراجعة قصيرة تساعد على التذكّر.',
        few: 'آخر تدريب كان منذ {count} أيّام. مراجعة قصيرة تساعد على التذكّر.',
        many: 'آخر تدريب كان منذ {count} يومًا. مراجعة قصيرة تساعد على التذكّر.',
        other: 'آخر تدريب كان منذ {count} يوم. مراجعة قصيرة تساعد على التذكّر.',
      },
      prerequisite: 'هدف «{objective}» يحتاج إلى تدريب، وهذا الهدف أساس له.',
      easier: 'نقترح تمارين أسهل مع تلميحات حسب النتائج الأخيرة ({percent}٪).',
      practice: '{percent}٪ من الإجابات الأخيرة صحيحة. مزيد من التدريب يثبّت التعلّم.',
      next: 'الأهداف السابقة في تقدّم جيّد، فهذا هو الهدف الموالي.',
      start: 'أوّل هدف في هذه المادّة.',
    },
  },
  mistakes: {
    'off-by-one': 'نتيجة تزيد أو تنقص بواحد (العدّ)',
    'wrong-operation': 'استعمال عمليّة أخرى غير المطلوبة',
    'place-value': 'الخلط بين الآحاد والعشرات والمئات',
    regrouping: 'الاحتفاظ بالعشرة أو أخذها من الخانة المجاورة',
    'smaller-from-larger': 'طرح الرقم الأصغر من الأكبر في كلّ خانة بدل أخذ عشرة',
    'table-slip': 'الخلط بين نتائج متجاورة في جدول الضرب',
    counting: 'عدّ الأشياء',
    'similar-letter-shape': 'التمييز بين الحروف المتشابهة في الشكل',
    'similar-sound': 'التمييز بين الأصوات المتقاربة',
    'letter-position': 'أشكال الحرف حسب موقعه في الكلمة',
    harakat: 'التمييز بين الحركات',
    'letter-order': 'ترتيب الحروف في الكلمة',
    'word-order': 'ترتيب الكلمات في الجملة',
    spelling: 'رسم الكلمات',
    article: 'اختيار أداة التعريف أو التنكير',
    agreement: 'المطابقة في العدد',
    conjugation: 'تصريف الأفعال',
    vocabulary: 'معاني الكلمات',
    comprehension: 'فهم النصّ',
    'grammar-role': 'تحديد وظائف الكلمات في الجملة',
    classification: 'التصنيف',
    misconception: 'فكرة علميّة تحتاج إلى توضيح',
    unknown: 'أخطاء متنوّعة',
  },
  parent: {
    gate: {
      title: 'فضاء الوليّ',
      intro: 'أدخل الرمز السرّي للوليّ.',
      pin: 'الرمز السرّي',
      unlock: 'دخول',
      wrong: {
        zero: 'رمز خاطئ.',
        one: 'رمز خاطئ. بقيت محاولة واحدة.',
        two: 'رمز خاطئ. بقيت محاولتان.',
        few: 'رمز خاطئ. بقيت {count} محاولات.',
        many: 'رمز خاطئ. بقيت {count} محاولة.',
        other: 'رمز خاطئ. بقيت {count} محاولة.',
      },
      locked: 'محاولات كثيرة. انتظر قليلًا ثمّ أعد المحاولة (الثواني المتبقّية: {seconds}).',
      forgot: 'نسيت الرمز؟',
      checking: 'جارٍ التحقّق…',
      childNote: 'هذا الفضاء مخصّص للأولياء.',
    },
    setup: {
      title: 'إنشاء رمز سرّي للوليّ',
      intro: 'يحمي هذا الرمز فضاء الوليّ من الدخول غير المقصود من طرف الطفل.',
      pin: 'رمز من 4 إلى 6 أرقام',
      confirm: 'أعد كتابة الرمز',
      mismatch: 'الرمزان غير متطابقين.',
      format: 'الرمز يتكوّن من 4 إلى 6 أرقام.',
      tooSimple: 'اختر رمزًا أصعب: تجنّب الأرقام المتكرّرة أو المتتالية.',
      create: 'إنشاء الرمز',
      limitation:
        'تنبيه: يمنع الرمز الأطفال من الدخول، لكنّه لا يحمي البيانات من شخص يملك تحكّمًا كاملًا في الجهاز.',
    },
    recovery: {
      title: 'رمز الاسترجاع',
      intro:
        'احتفظ بهذا الرمز في مكان آمن (على ورقة مثلًا). يُستعمل إذا نسيت الرمز السرّي، ولن يُعرض مرّة أخرى.',
      copy: 'نسخ',
      copied: 'تمّ النسخ',
      saved: 'كتبت رمز الاسترجاع في مكان آمن',
      continue: 'مواصلة',
    },
    reset: {
      title: 'استرجاع الدخول',
      code: 'رمز الاسترجاع',
      newPin: 'رمز سرّي جديد',
      submit: 'تغيير الرمز',
      wrongCode: 'رمز الاسترجاع غير صحيح.',
    },
    dashboard: {
      title: 'فضاء الوليّ',
      lock: 'قفل',
      learners: 'المتعلّمون',
      noLearners: 'لا يوجد أيّ ملفّ متعلّم بعد.',
      open: 'عرض التقرير',
      dataLink: 'البيانات والخصوصيّة',
      settingsLink: 'الأمان',
    },
    report: {
      title: 'تقرير {name}',
      anonymousChild: 'طفلك',
      level: 'المستوى: {level}',
      estimateNote:
        'كلّ الأرقام مبنيّة على التمارين المسجّلة على هذا الجهاز فقط، وهي تقديرات للتقدّم وليست تقييمًا مدرسيًّا.',
      learningTime: 'وقت التعلّم',
      sessions: 'الحصص المكتملة',
      exercises: 'الأسئلة المُجاب عنها',
      accuracy: 'صحيحة من المحاولة الأولى',
      thisWeek: 'هذا الأسبوع',
      allTime: 'منذ البداية',
      bySubject: 'حسب المادّة',
      answered: 'الأسئلة: {count}',
      mastered: 'أهداف في مرحلة الإتقان المبدئي',
      needsPractice: 'أهداف تحتاج إلى تدريب',
      inProgress: 'أهداف قيد التعلّم',
      none: 'لا شيء بعد.',
      improvement: 'التطوّر عبر الأسابيع',
      weekOf: 'أسبوع {date}',
      notEnoughWeeks: 'نحتاج إلى أسبوعين من التمارين على الأقلّ لعرض التطوّر.',
      recentSessions: 'آخر الحصص',
      noSessions: 'لم تُسجَّل أيّ حصّة بعد.',
      recommended: 'الأنشطة المقترحة',
      weekly: 'ملخّص الأسبوع',
      print: 'طباعة التقرير',
      export: 'تصدير بيانات هذا المتعلّم',
      accuracyTable: 'جدول الدقّة حسب المادّة',
      chartAlt: 'نسبة الإجابات الصحيحة من المحاولة الأولى لكلّ أسبوع',
      abandoned: 'حصّة غير مكتملة',
      why: 'لماذا؟',
    },
    summary: {
      practised: 'تدرّب {name} على: {objectives}.',
      strong:
        '«{objective}»: إجابات صحيحة في أغلب الأحيان ({correct} من {answered} من المحاولة الأولى).',
      developing: '«{objective}»: في تحسّن ({correct} من {answered} من المحاولة الأولى).',
      needsPractice: '«{objective}» يحتاج إلى مزيد من التدريب ({correct} من {answered}).',
      needsPracticeMistake: '«{objective}» يحتاج إلى مزيد من التدريب، خاصّة: {mistake}.',
      fewAnswers: 'تقدير أوّلي: عدد الإجابات ({count}) ما زال قليلًا.',
      mastery: 'إتقان مبدئي لـ«{objective}»: نتائج ثابتة في أيّام مختلفة.',
      perseverance: 'إجابات صُحّحت في المحاولة الثانية: {count}. مثابرة جميلة!',
      nextStep: 'الخطوة المقترحة: {step}',
      weekSessions:
        'هذا الأسبوع — الحصص: {sessions}، وقت التعلّم: {minutes} تقريبًا، الأسئلة: {answered}.',
      weekAccuracy: '{percent}٪ من الإجابات صحيحة من المحاولة الأولى.',
      weekMastered: 'أهداف جديدة في مرحلة الإتقان المبدئي: {objectives}.',
      weekNeeds: 'أهداف تحتاج إلى تدريب: {objectives}.',
      weekEmpty: 'لم تُسجَّل أيّ حصّة هذا الأسبوع.',
    },
    security: {
      title: 'الأمان',
      changePin: 'تغيير الرمز السرّي',
      currentPin: 'الرمز الحالي',
      newPin: 'الرمز الجديد',
      pinChanged: 'تمّ تغيير الرمز.',
      rotate: 'إنشاء رمز استرجاع جديد',
      rotateHint: 'سيتوقّف رمز الاسترجاع القديم عن العمل.',
    },
  },
  settings: {
    title: 'الإعدادات',
    language: 'لغة التطبيق',
    preferences: 'تفضيلات {name}',
    deviceLanguageHint: 'تُستعمل هذه اللغة قبل اختيار متعلّم.',
    profile: 'الملفّ',
    level: 'القسم',
    editProfile: 'حفظ التغييرات',
    saved: 'تمّ الحفظ.',
    privacyLink: 'الخصوصيّة والبيانات',
    contentStatus: 'حالة المحتوى',
    contentVersion: 'نسخة المحتوى: {version}',
  },
  privacy: {
    title: 'الخصوصيّة والبيانات',
    intro: 'صُمّم تطبيق {app} ليعمل دون حساب ودون جمع معطيات شخصيّة.',
    stored:
      'ما الذي نحفظه؟ ملفّ متعلّم بمعرّف عشوائي، والمستوى، واللقب الاختياري، والإجابات والتقدّم. كلّ ذلك على هذا الجهاز فقط.',
    notStored:
      'لا نطلب الاسم الحقيقي ولا تاريخ الميلاد ولا اسم المدرسة ولا أيّ وسيلة اتّصال، ولا نرسل أيّ معطيات إلى خادم.',
    noTrackers: 'لا إعلانات ولا أدوات تحليل أو تتبّع.',
    localWarningTitle: 'مهمّ: البيانات محلّيّة',
    localWarning:
      'مسح بيانات المتصفّح أو حذف التطبيق أو فقدان الجهاز يحذف كلّ التقدّم. صدّر نسخة احتياطيّة بانتظام.',
    persist: 'طلب حفظ دائم من المتصفّح',
    persistGranted: 'وافق المتصفّح على الحفظ الدائم.',
    persistDenied: 'لم يوافق المتصفّح. صدّر نسخة احتياطيّة بانتظام.',
    persistUnsupported: 'هذا المتصفّح لا يدعم طلب الحفظ الدائم.',
    backupTitle: 'نسخة احتياطيّة',
    backupHowTo:
      'اضغط «تصدير» لتنزيل ملفّ. احفظه في مكان خاصّ (فهو غير مشفّر). لاسترجاعه على هذا الجهاز أو على جهاز آخر، استعمل «استيراد».',
    exportAll: 'تصدير كلّ البيانات',
    exported: 'تمّ إنشاء الملفّ {file}.',
    importTitle: 'استيراد نسخة احتياطيّة',
    importChoose: 'اختر ملفّ نسخة احتياطيّة (.json)',
    importPreview: {
      zero: 'لا يحتوي الملفّ على أيّ متعلّم.',
      one: 'يحتوي الملفّ على متعلّم واحد.',
      two: 'يحتوي الملفّ على متعلّمَين.',
      few: 'يحتوي الملفّ على {count} متعلّمين.',
      many: 'يحتوي الملفّ على {count} متعلّمًا.',
      other: 'يحتوي الملفّ على {count} متعلّم.',
    },
    importConflict: 'بعض هذه الملفّات موجودة على هذا الجهاز.',
    importReplace: 'تعويض الموجود',
    importCopy: 'إضافة كنسخة',
    importConfirm: 'استيراد',
    importDone: 'تمّ الاستيراد.',
    importErrors: {
      tooLarge: 'الملفّ كبير جدًّا.',
      notJson: 'هذا الملفّ ليس نسخة احتياطيّة صالحة.',
      wrongFormat: 'هذا الملفّ لا يخصّ {app}.',
      newerVersion: 'أُنشئ هذا الملفّ بنسخة أحدث من {app}. حدّث التطبيق أوّلًا.',
      invalid: 'الملفّ تالف أو ناقص، ولم نغيّر أيّ شيء.',
      inconsistent: 'محتوى الملفّ غير متناسق، ولم نغيّر أيّ شيء.',
      empty: 'الملفّ فارغ.',
      readFailed: 'تعذّرت قراءة الملفّ.',
    },
    deleteTitle: 'حذف البيانات',
    deleteLearner: 'حذف ملفّ {name}',
    deleteLearnerBody: 'سيُحذف الملفّ وكلّ إجاباته وجوائزه نهائيًّا من هذا الجهاز.',
    deleteAll: 'حذف كلّ البيانات',
    deleteAllBody: 'ستُحذف كلّ الملفّات والتقدّم والرمز السرّي نهائيًّا من هذا الجهاز.',
    typeToConfirm: 'اكتب «{word}» للتأكيد',
    confirmWord: 'حذف',
    deleted: 'تمّ الحذف.',
  },
  feedback: {
    rateTitle: 'هل أعجبتك هذه اللعبة؟',
    liked: 'أعجبتني',
    soso: 'عاديّة',
    disliked: 'لم تعجبني',
    rateThanks: 'شكرًا! سيطّلع وليّك على رأيك.',
    report: 'أبلغ عن مشكلة',
    reportTitle: 'ما المشكلة في هذا السؤال؟',
    reasons: {
      unclear: 'السؤال غير واضح',
      wrongAnswer: 'أظنّ أنّ الإجابة خاطئة',
      tooHard: 'صعب جدًّا',
      something: 'شيء آخر',
    },
    reportSend: 'أرسلها إلى وليّي',
    reportThanks: 'شكرًا! سيطّلع وليّك على ملاحظتك.',
  },
  parentFeedback: {
    title: 'الملاحظات والاقتراحات',
    intro: 'رأيكم يساعدنا على تحسين {app}. نقرأ كلّ رسالة ونصلح الأخطاء في التحديثات القادمة.',
    privacyNote:
      'لا نرسل معرّفات الأطفال ولا ألقابهم ولا نتائجهم، بل فقط ما تكتبونه هنا وما اختاره الأطفال من ردود جاهزة.',
    childrenTitle: 'ما لاحظه الأطفال',
    childrenEmpty: 'لم يترك الأطفال أيّ ملاحظة جديدة.',
    includeChildren: 'أرفق ملاحظات الأطفال',
    ratingEntry: '«{game}»: {mood}',
    problemEntry: 'سؤال في «{objective}»: {reason}',
    formTitle: 'رسالتكم',
    role: 'أنا',
    roles: { parent: 'وليّ', teacher: 'مربٍّ أو معلّم', another: 'غير ذلك' },
    topic: 'الموضوع',
    topics: {
      idea: 'فكرة أو اقتراح',
      problem: 'خلل في التطبيق',
      content: 'خطأ في محتوى تعليمي',
      praise: 'رأي إيجابي',
      misc: 'موضوع آخر',
    },
    message: 'الرسالة',
    messageHint: 'من فضلكم لا تكتبوا أسماء أو معطيات شخصيّة عن الطفل.',
    contact: 'بريد للتواصل (اختياري)',
    contactHint: 'اتركوه فارغًا إن لم تحتاجوا إلى ردّ. لا يُستعمل لأيّ غرض آخر.',
    technical: 'أرفق معلومات تقنيّة لا تكشف الهويّة (نسخة التطبيق والمحتوى واللغة وحجم الشاشة)',
    preview: 'ما سيُرسَل بالضبط',
    send: 'إرسال',
    sending: 'جارٍ الإرسال…',
    sent: 'وصلت رسالتكم. شكرًا!',
    empty: 'اكتبوا رسالة أو أرفقوا ملاحظات الأطفال قبل الإرسال.',
    errorOffline: 'لا يوجد اتّصال بالإنترنت. حاولوا لاحقًا أو انسخوا الرسالة.',
    errorRejected: 'تعذّر قبول الرسالة (ربّما لأنّها طويلة جدًّا).',
    errorServer: 'الخدمة غير متاحة حاليًّا. حاولوا لاحقًا أو انسخوا الرسالة.',
    copy: 'نسخ الرسالة',
    copied: 'تمّ النسخ',
    email: 'إرسال بالبريد الإلكتروني',
  },
  units: {
    minutes: {
      zero: 'أقلّ من دقيقة',
      one: 'دقيقة واحدة',
      two: 'دقيقتان',
      few: '{count} دقائق',
      many: '{count} دقيقة',
      other: '{count} دقيقة',
    },
  },
};

export type Messages = typeof ar;
